// extracted by mini-css-extract-plugin
export default {"DleRecordTypeDetail":"DleRecordTypeDetail_DleRecordTypeDetail__QH7la"};